import { FollowUpsMessage } from '@/store/types'
import { Store } from '@/store'
import AssistantMessage from '@/components/AssistantMessage'
import { Button } from '@/components/ui/button'
import * as Sentry from '@sentry/react'
import { analytics } from '@/lib/analytics'

interface FollowUpSuggestionsProps {
	message: FollowUpsMessage
}

const FollowUpSuggestions = ({ message }: FollowUpSuggestionsProps) => {
	const { chatId } = Store.useBoundStore.getState().chats[
		Object.keys(Store.useBoundStore.getState().chats).find(
			id => Store.useBoundStore.getState().chats[id].messages.includes(message)
		) || ''
	]

	const handleFollowUpClick = (followUp: string) => {
		try {
			Store.setState(draft => {
				draft.chatInputText = followUp
			})
			analytics.followUpClicked()
		} catch (error) {
			Sentry.captureException(error, {
				tags: {
					type: 'ui-interaction',
					id: 'follow-up-click',
				},
			})
		}
	}

	if (!message.content?.followUps || message.content.followUps.length === 0) {
		return null
	}

	return (
		<div className='rounded-lg bg-opacity-10 bg-green-700 p-3 text-left'>
			<AssistantMessage>
				<div className='space-y-2'>
					<p className='text-sm text-primary-foreground font-semibold mb-3'>
						Explore these related questions:
					</p>
					<div className='flex flex-wrap gap-2'>
						{message.content.followUps.map((followUp, index) => (
							<Button
								key={index}
								onClick={() => handleFollowUpClick(followUp)}
								className='text-xs py-1 px-3 bg-[#249F7E] hover:bg-[#1a7a62]
									text-white rounded-2xl font-normal'
							>
								{followUp}
							</Button>
						))}
					</div>
				</div>
			</AssistantMessage>
		</div>
	)
}

export default FollowUpSuggestions
